import {z} from '@hono/zod-openapi';

const decimalSchema = z.string().regex(/^\d{1,18}$|^\d{1,18}\.\d{1,8}$/);
const dateSchema = z.string().date();
const identifierSchema = z.string().trim().min(1).max(100);
const taxSchema = z.discriminatedUnion('kind', [
  z.object({kind: z.literal('exempt'), code: identifierSchema, reason: z.string().min(1)}),
  z.object({kind: z.literal('percentage'), rate: decimalSchema}),
]);

/** Lossless source audit projection of the explicitly selected Nissan DIGLAS export. */
export const nissanDiglasInvoiceSchema = z.object({
  invoiceNumber: identifierSchema,
  issueDate: dateSchema,
  deliveryDate: dateSchema,
  sourcePaymentDate: dateSchema.nullable(),
  completenessIndicator: z.boolean(),
  currency: z.literal('CZK'),
  sourceExchangeRateHuf: decimalSchema,
  supplier: z.object({
    name: z.string().trim().min(1),
    taxpayerId: z.string().regex(/^\d{8}$/),
    vatCode: z.string().regex(/^\d$/),
    countyCode: z.string().regex(/^\d{2}$/),
    countryCode: z.literal('HU'),
  }),
  customer: z.object({
    name: z.string().trim().min(1),
    vatNumber: z.string().regex(/^CZ\d{8,10}$/),
    countryCode: z.literal('CZ'),
  }),
  lines: z
    .array(
      z.object({
        lineNumber: z.string().regex(/^[1-9]\d{0,8}$/),
        partNumber: identifierSchema,
        description: z.string().trim().min(1),
        quantity: decimalSchema,
        unit: z.literal('PIECE'),
        unitPrice: decimalSchema,
        netAmount: decimalSchema,
        vat: taxSchema,
        vatAmount: decimalSchema,
        grossAmount: decimalSchema,
      })
    )
    .min(1)
    .max(10000),
  netAmount: decimalSchema,
  vatAmount: decimalSchema,
  grossAmount: decimalSchema,
});

export type NissanDiglasInvoice = z.infer<typeof nissanDiglasInvoiceSchema>;
